<template>
  <div>
    <v-dialog v-model="visible" max-width="380px">
      <v-card style="text-align: center;">
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>微信支付</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <qriously :value="this.url" :size="190" class="qrcode"/>
        <v-card-text>
          <ul class="health-list">
            <li>请使用微信扫码二维码以完成支付</li>
          </ul>
        </v-card-text>
        <v-btn @click="submit" color="primary">已支付</v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    url:{
      type:String
    },
    orderCode:{
      type:String
    },
    isAdd:{
      type:Boolean
    }
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    },
    businessId() {
      return this.user && this.user.userId;
    },
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods: {
    submit(){
      this.loading = true;
      const data = {
        orderCode: this.orderCode,
        userId: this.businessId
      }
      this.$axios
        .post('/app/api/tk/queryOrderStatus', data)
        .then(res => {
          console.log(res);
          if(res.data === 0){
            this.$message.error('待支付');
          } else if(res.data === 1){
            this.$message.error('支付中');
          } else if(res.data === 2){
            if (this.isAdd) {
              this.$emit("pay", true);
              this.visible = false
            } else {
              this.$router.push({ name: "result",});
            }
          } else if (res.data === 3) {
            this.$message.error('支付失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    }
  }
};
</script>